module.exports = __webpack_public_path__ + "static/media/AWT Mask Video_Convention_1628878609494.49951087.docx";